import { FlarePooledFlrAbi } from '../abis/flarePooled'
import type { LstRegistryEntry } from '../registry'
import { ONE_E18, toBigInt, type LstReader } from './shared'

/**
 * Flare pooled-staking LST reader — SparkDEX `stFLR` / Sceptre `sFLR`.
 *
 * Lido-style rebasing share token: three reads on the share contract.
 *   - `totalPooledFlr()`            → total underlying FLR held
 *   - `totalShares()`               → non-rebasing shares minted
 *   - `getPooledFlrByShares(1e18)`  → 1e18-scaled rate (1 share → FLR)
 *
 * Not ERC-4626 (no `asset()`/`totalAssets()`), so a dedicated reader rather
 * than the generic 3-call ERC-4626 path.
 */
export const readerFlarePooledFlr = (entry: LstRegistryEntry): LstReader => ({
  calls: [
    { address: entry.address, name: 'totalPooledFlr', params: [] },
    { address: entry.address, name: 'totalShares', params: [] },
    { address: entry.address, name: 'getPooledFlrByShares', params: [ONE_E18] },
  ],
  abis: [FlarePooledFlrAbi, FlarePooledFlrAbi, FlarePooledFlrAbi],
  parse: ([pooledFlr, shares, rate]) => {
    const totalAssets = toBigInt(pooledFlr)
    const totalSupply = toBigInt(shares)
    const exchangeRate = toBigInt(rate)
    if (
      totalAssets === undefined ||
      totalSupply === undefined ||
      exchangeRate === undefined
    ) {
      return undefined
    }
    return { totalAssets, totalSupply, exchangeRate }
  },
})
